import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { PLACEMENT_STATUS_LABELS, trackFeaturedPlacementEvent } from "../../../constants/automapFeaturedPlacementConstants";
import { fetchPlacementsDashboard } from "../../../services/automapFeaturedPlacementApi";
import { AdminPlacementsNav } from "./AdminPlacementsShared";

function MetricCard({ label, value, href }) {
  const inner = (
    <>
      <span className="admin-dashboard__metric-label">{label}</span>
      <strong className="admin-dashboard__metric-value">{value ?? "—"}</strong>
    </>
  );
  return href ? (
    <Link to={href} className="admin-dashboard__metric-card admin-dashboard__metric-card--link">{inner}</Link>
  ) : (
    <div className="admin-dashboard__metric-card">{inner}</div>
  );
}

export default function AdminPlacementsDashboardPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const payload = await fetchPlacementsDashboard();
      setData(payload.dashboard);
      trackFeaturedPlacementEvent("admin_placements_dashboard_viewed");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const t = data?.totals || {};
  const p = data?.performance || {};

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Destacados" title="Placements destacados" description="Visibilidad patrocinada con etiquetado transparente. Sin checkout automático." />
      <AdminAutomotiveNav active="placements" />
      <AdminPlacementsNav active="dashboard" />
      <main className="admin-console__main wrap">
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading && data ? (
          <>
            <div className="admin-dashboard__metrics-grid">
              <MetricCard label="Activos" value={t.active} href="/admin/placements/listings?activeNow=true" />
              <MetricCard label="Programados" value={t.scheduled} href="/admin/placements/schedule" />
              <MetricCard label="Expirados" value={t.expired} />
              <MetricCard label="Pausados" value={t.paused} />
              <MetricCard label="Pendientes aprobación" value={t.needsApproval} />
              <MetricCard label="Issues elegibilidad" value={t.eligibilityIssues} />
              <MetricCard label="Por vencer" value={t.endingSoon} />
              <MetricCard label="Dealers usando" value={t.dealersUsing} />
              <MetricCard label="Solicitudes dealer" value={data.pendingRequests} />
              <MetricCard label="Impresiones" value={p.impressions} href="/admin/placements/performance" />
              <MetricCard label="Clics" value={p.clicks} />
              <MetricCard label="WhatsApp" value={p.whatsappClicks} />
              <MetricCard label="Leads" value={p.leads} />
              <MetricCard label="CTR" value={p.ctr != null ? `${p.ctr}%` : "—"} />
              <MetricCard label="Conv. leads" value={p.leadConversionRate != null ? `${p.leadConversionRate}%` : "—"} />
            </div>
            <section className="dealer-state-box">
              <h3>Top performance</h3>
              {!data.topPerforming?.length ? <p className="muted">Sin datos aún.</p> : (
                <ul>{data.topPerforming.map((r) => <li key={r.id}>{r.placementName} · {r.dealerName} · {r.performance?.clicks} clics</li>)}</ul>
              )}
            </section>
            <div className="import-actions">
              <Link className="admin-btn admin-btn--primary" to="/admin/placements/listings">Gestionar listings</Link>
              <Link className="admin-btn" to="/admin/placements/rules">Ver reglas</Link>
            </div>
            <p className="muted">{data.rulesNote}</p>
          </>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
